import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class GetBankStatementItemsItem {
  @Expose()
  @IsString()
  accountingDate!: string; // "2021-12-15T00:00:00";
  @Expose()
  @IsNumber()
  amount!: number; // 578.45;
  @Expose()
  @IsNumber()
  amountLeft!: number; // 578.45;
  @Expose()
  @IsOptional()
  @IsString()
  comment!: null | string;
  @Expose()
  @IsOptional()
  @IsString()
  contractorFilterData!: null | string;
  @Expose()
  @IsString()
  currency!: string; // "PLN";
  @Expose()
  @IsString()
  description!: string; // "PRZELEW KRAJOWY  Z RACH.: 83105000861000009031190888 OD:  INTEGER.PL SPÓŁKA AKCYJNA UL. WIELICKA 28 30-552 KRAKÓW TYT.:  /NIP/8133380514/078 367/12/2021/KOR/RZE DATA STEMPLA:  14.12.2021 TNR: 197081088436142.340001 ";
  @Expose()
  @IsNumber()
  id!: number; // 643849;
  @Expose()
  @IsBoolean()
  isDeleted!: boolean; // false;
  @Expose()
  @IsNumber()
  recordStampId!: number; // 112519;
  @Expose()
  @IsString()
  transactionDate!: string; // "2021-12-15T00:00:00";
  @Expose()
  @IsString()
  transactionDescriptionFilterData!: string; // "367/12/2021/KOR/RZE";
  @Expose()
  @IsOptional()
  @IsString()
  fileId!: string;
  @Expose()
  @IsString()
  contractorName!: string;
  @Expose()
  @IsOptional()
  @IsString()
  contractorId!: string;
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsBoolean()
  @Expose()
  userHasPermissionToEditLocked!: boolean;
}

export class GetBankStatementItemsResponse extends GenericTableResponse<GetBankStatementItemsItem> {
  @Type(() => GetBankStatementItemsItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GetBankStatementItemsItem>;
}
